module.exports = __webpack_public_path__ + "static/media/typical17.0492679c.jpg";